import { addClass, removeClass } from '@utils/domUtils';

export default class NotificationList {
  static selectorString() {
    return '.NotificationList';
  }

  render(node, props) {
    this.emptyNotificationlistMessage = node.querySelector('.empty-notificationlist-message');
    this.refresh();
  }

  refresh() {
    this.items = [...this.node.querySelectorAll('.NotificationItem')];

    if (this.items.length > 0) {
      addClass(this.emptyNotificationlistMessage, 'd-none');
    } else {
      removeClass(this.emptyNotificationlistMessage, 'd-none');
    }
  }
}
